import type { RoleCapability, SystemRole } from '@peles/shared';
import { apiClient } from './client';

/** `/capabilities` — what a role may do, as the office sets it in Settings → Messaging. */
const BASE = '/capabilities';

/** One cell of the grid. */
export interface CapabilityCell {
  role: SystemRole;
  capability: RoleCapability;
  allowed: boolean;
}

/** Every capability the caller's role holds now. */
export async function getMyCapabilities(): Promise<RoleCapability[]> {
  const { data } = await apiClient.get<{ capabilities: RoleCapability[] }>(`${BASE}/mine`);
  return data.capabilities;
}

/** The whole grid — administrators only. */
export async function getCapabilityGrid(): Promise<CapabilityCell[]> {
  const { data } = await apiClient.get<{ cells: CapabilityCell[] }>(BASE);
  return data.cells;
}

export async function setCapability(cell: CapabilityCell): Promise<CapabilityCell> {
  const { data } = await apiClient.put<CapabilityCell>(BASE, cell);
  return data;
}
